export const user_routes = [
    // {
    //     path: '/',
    //     name: 'index',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/dashboard/Dashboard" } },
    //     meta: { requireNone: true, requireAuth: true, requireAdmin: false },
    // },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/dashboard/Dashboard" } },
        meta: { requireNone: true, requireAuth: true, requireAdmin: false },
    },
    {
        path: '/menu',
        name: 'menu',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/menu/Menu" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/category',
        name: 'category',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/category/Category" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/banners',
        name: 'banner',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/banner/Banner" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/statistics/Statistics" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/doyouknow',
        name: 'doyouknow',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/doyouknow/Doyouknow" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/cocktail',
        name: 'cocktail',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/cocktail/Cocktail" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/filter',
        name: 'filter',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/filter/Filter" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    // {
    //     path: '/manufacturer',
    //     name: 'manufacturer',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/manufacturer/Manufacturer" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    {
        path: '/products',
        name: 'products',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/products/Products" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    // {
    //     path: '/product_type',
    //     name: 'product_type',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/product_type/ProductType" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/weight_unit',
    //     name: 'weight_unit',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/manufacturer/Manufacturer" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/length_unit',
    //     name: 'length_unit',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/manufacturer/Manufacturer" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
];
